<script lang="ts">
    import CtaDivider from '$lib/components/word-list/cta-divider.svelte';

    interface Props {
        numberOfItems: number;
        index: number
    }

    let {
        numberOfItems,
        index
    }: Props = $props()

    let position = index + 1

    const minSections = 1 //= 0 dividers
    const maxSections = 5 //= 4 dividers
    const minItemsPerSection = 10

    const sections = Math.max(minSections, Math.min(maxSections, Math.floor(numberOfItems / minItemsPerSection)));

    const dividerDistance = Math.floor(numberOfItems / sections)

    const dividerPositions = Array.from({length: sections - 1}, (_, i) => Math.floor((i + 1) * dividerDistance));

</script>

{#if position === dividerPositions[0]}

    <CtaDivider position={1}/>

{:else if position === dividerPositions[1]}

    <CtaDivider position={2}/>

{:else if position === dividerPositions[2]}

    <CtaDivider position={3}/>

{:else if position === dividerPositions[3]}

    <CtaDivider position={4}/>

{/if}
